import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useUsuariosCadastroPagination
 */
type State = {
  grupoAcessoUsuario: PaginationProperties,
  centroCustoRestricaoUsuario: PaginationProperties,
};

type Action = {
  grupoAcessoUsuarioSetter: SetPaginationProperties,
  centroCustoRestricaoUsuarioSetter: SetPaginationProperties,
};

export const useUsuariosCadastroPagination = create<State & Action>((set) => ({
  grupoAcessoUsuario: InitializePaginationProperties({ rowsPerPage: 100 }),
  centroCustoRestricaoUsuario: InitializePaginationProperties({ rowsPerPage: 100 }),
  grupoAcessoUsuarioSetter: InitializeSetPaginationProperties(set, 'grupoAcessoUsuario'),
  centroCustoRestricaoUsuarioSetter: InitializeSetPaginationProperties(set, 'centroCustoRestricaoUsuario'),

}));